
const TagNode = ({ tag, childrenObj, activeFilters, onToggleFilter, depth = 0 }) => {
  const tagId = `tag-${tag}`;
  const isActive = activeFilters?.includes(tagId);
  return (
    <div className={`flex flex-col gap-1 w-full ${depth > 0 ? 'ml-2 mt-0.5 border-l-2 border-zinc-100 pl-2' : ''}`}>
      <label className="flex items-center gap-1.5 cursor-pointer group">
        <div className="relative flex items-center justify-center">
          <input
            type="checkbox"
            checked={isActive}
            onChange={() => onToggleFilter(tagId)}
            className="peer appearance-none w-3.5 h-3.5 border-2 border-zinc-300 rounded hover:border-blue-500 checked:bg-blue-500 checked:border-blue-500 transition-colors cursor-pointer"
          />
          <svg className="absolute w-2 h-2 text-white pointer-events-none opacity-0 peer-checked:opacity-100" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={4}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
          </svg>
        </div>
        <span className="text-[10px] font-bold text-zinc-600 group-hover:text-zinc-900 transition-colors">
          {tag}
        </span>
      </label>
      {Object.keys(childrenObj).length > 0 && (
        <div className="flex flex-col gap-1">
          {Object.entries(childrenObj).map(([childTag, grandChildren]) => (
            <TagNode 
              key={childTag} 
              tag={childTag} 
              childrenObj={grandChildren} 
              activeFilters={activeFilters} 
              onToggleFilter={onToggleFilter} 
              depth={depth + 1} 
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default TagNode;
